import { ComplianceAssetRow, ComplianceRiskRow } from '../../common/types';

export type ComplianceSideMenuDataType = {
  controlName: string;
  controlDescription: string;
  controlId: string;
  complianceStandardLabel: string;
  complianceStandard: string;
  sectionName: string;
  sectionId: string;
  categoryLabel: string;
  complianceScore: number;
  checksBreakdown: { compliant?: number; nonCompliant?: number; ignored?: number };
  misconfigurationRisks: ComplianceRiskRow[];
  userBehaviorRisks: ComplianceRiskRow[];
  resourceAssets: ComplianceAssetRow[];
  identityAssets: ComplianceAssetRow[];
  misconfigurationRisksTotalCount: number;
  userBehaviorRisksTotalCount: number;
  resourceAssetsTotalCount: number;
  identityAssetsTotalCount: number;

  totalChecks: number;

  // controlIndicatorIds used for Drawer BE query, and Risks `View all` query.
  misconfigurationRisksIndicatorIds: number[];
  userBehaviorRiskIndicatorIds: number[];

  // Required info for 'View All' assets.
  controlExtraDetails?: {
    controlOperatingSystem?: number[];
    controlApplicableResource?: { endpointId: string; endpointName: string }[];
  };
};

export enum ComplianceSideMenuTabs {
  Description,
  Risks,
  Assets,
}

export type RiskType = 'misconfiguration' | 'user-behavior-risk';
export type AssetType = 'resource-asset' | 'identity-asset';
